import { mode, getColor } from "@chakra-ui/theme-tools";
import { ComponentStyleConfig } from "@chakra-ui/react";

const PinInputComponentStyle: ComponentStyleConfig = {
  variants: {
    outline: (props) => {
      const { theme, focusBorderColor: fc, errorBorderColor: ec } = props;

      return {
        borderColor: mode("gray.500", "whiteAlpha.300")(props),
        color: mode("gray.800", "gray.100")(props),

        _hover: {
          borderColor: mode("gray.600", "whiteAlpha.400")(props)
        },

        _focusVisible: {
          borderWidth: "2px",
          borderColor: fc || mode("blue.500", "blue.200")(props),
          boxShadow: `0 0 0 1px ${
            fc || getColor(theme, mode("blue.500", "blue.200")(props))
          }`
        },

        _invalid: {
          borderWidth: "2px",
          borderColor: ec || mode("red.600", "red.300")(props),
          boxShadow: `0 0 0 1px ${
            ec || getColor(theme, mode("red.600", "red.300")(props))
          }`
        }
      };
    }
  }
};

export { PinInputComponentStyle };
